// What a project asks of you right now. The home list groups by this, never
// by date: a failed run needs a look, a running one cannot be opened, and a
// finished one is a trophy. Declaration order is display order.
import { isComplete, stepsDone, type Id, type Project } from './plan';

export type Standing = 'needsLook' | 'building' | 'underway' | 'notStarted' | 'finished';
export const STANDINGS: readonly Standing[] = ['needsLook', 'building', 'underway', 'notStarted', 'finished'];

export const STANDING_TITLE: Record<Standing, string> = {
  needsLook: 'Needs a look',
  building: 'Building',
  underway: 'Underway',
  notStarted: 'Not started',
  finished: 'Finished',
};

/** Live generation state is not on the project; the caller passes it in. */
export function standingOf(p: Project, live: { building?: boolean; failed?: boolean } = {}): Standing {
  if (live.building) return 'building';
  if (live.failed) return 'needsLook';
  if (isComplete(p)) return 'finished';
  return stepsDone(p) > 0 ? 'underway' : 'notStarted';
}

export interface Group { standing: Standing; title: string; projects: Project[] }

export function groupedByStanding(projects: Project[], building: Set<Id> = new Set(), failed: Set<Id> = new Set()): Group[] {
  const by = new Map<Standing, Project[]>();
  for (const p of projects) {
    if (p.deletedAt) continue;
    const s = standingOf(p, { building: building.has(p.id), failed: failed.has(p.id) });
    by.set(s, [...(by.get(s) ?? []), p]);
  }
  return STANDINGS.flatMap((standing) => {
    const list = by.get(standing);
    return list?.length ? [{ standing, title: STANDING_TITLE[standing], projects: list }] : [];
  });
}
